import { createSelector } from '@reduxjs/toolkit'
import { TimelineReference } from './schemas'
import { RootState } from '@/store/store'
import { TimelineReferencesRecord } from './slice'

/**
 * Select: Timeline References by Job ID
 *
 * Returns the record of timeline references for the given job id, or null if it does not exist.
 */
export const selectTimelineReferencesByJobId = createSelector(
  [(state: RootState) => state.timelineReferencesState.references, (_: RootState, props: { timelineJobId: string | undefined | null }) => props.timelineJobId],
  (references, timelineJobId): TimelineReferencesRecord | null => {
    if (!timelineJobId) return null
    return references[timelineJobId] ?? null
  }
)

/**
 * Select: Timeline Reference by ID
 *
 * Returns the timeline reference with the given id, or null if it does not exist.
 */
export const selectTimelineReferenceById = createSelector(
  [selectTimelineReferencesByJobId, (_: RootState, props: { timelineJobId: string | undefined | null; referenceId: string }) => props.referenceId],
  (references, referenceId): TimelineReference | null => {
    if (!references || !referenceId) return null
    return references[referenceId] ?? null
  }
)
